var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrban(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420.052,
    height: 461.891,
    viewBox: "0 0 420.052 461.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-171.83 -147.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M381.227,620V303.349c1.9-.132,3.34-.321,4.783-.321,44.661.01,89.323-.194,133.981.156,24.418.191,48.538,3.12,71.558,11.994,18.191,7.013,33.854,17.407,43.3,35.068,18.544,34.662,6.091,77.275-28.086,97.148-13.849,8.053-28.866,12.761-44.523,15.664a20.67,20.67,0,0,0-7.534,2.472c6.219,1.156,12.469,2.166,18.65,3.5,16.055,3.454,31.391,8.823,45.39,17.6,24.261,15.213,38.382,36.931,41.393,65.487,3.108,29.474-3.247,56.048-25.339,77.269-14.05,13.5-31.263,21.283-49.787,26.416-21.354,5.917-43.232,7.8-65.286,7.854q-67.737.162-135.476.061c-.8,0-1.609-.136-3.027-.263V620m171.486,32.378A75.2,75.2,0,0,0,590,616.97c13.352-26.016,15.41-53.451,8.866-81.639-9.8-42.215-39.159-66.566-82.338-67.738-24.474-.664-48.978-.251-73.468-.291a16.09,16.09,0,0,0-2.833.491v192c1.172.074,1.983.169,2.794.169,24.491,0,48.984.1,73.474-.066a95.3,95.3,0,0,0,36.217-7.513M439.862,385.5v78.291h5.973c18.165,0,36.332-.145,54.495.044a90.374,90.374,0,0,0,41.866-9.694c36.318-18.039,53.472-61.791,37.408-98.964-13.586-31.439-39.366-46.506-72.77-48.21-21.111-1.077-42.319-.233-63.483-.238-.965,0-1.929.131-3.489.244Z",
    transform: "translate(-69 -54)",
    fill: "#645f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M299.785,440.181c2.238,31.085,8.821,60.432,25.995,86.484,11.048,16.758,25.679,29.208,45.277,34.932,3.5,1.023,3.409,2.917,2.67,6.381-6.8-.956-13.675-1.708-20.467-2.915-25.481-4.529-49.128-13.427-69.07-30.438-24.252-20.688-36.631-47.8-41.016-78.783a243.37,243.37,0,0,1-2.222-33.334c-.192-71.8-.1-143.592-.1-215.388V202h58.316c0,2.8,0,5.582,0,8.362q.031,109.443.086,218.886C299.255,432.735,299.585,436.225,299.785,440.181Z",
    transform: "translate(-69 -54)",
    fill: "#635e5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M521.149,251v44.788l-1.785.528c-.5-1.511-1.419-3.019-1.429-4.533-.1-14.969-.049-29.94-.05-44.91,0-13.639-.058-27.279.044-40.918.01-1.378.951-2.75,1.46-4.124.59,1.419,1.683,2.834,1.7,4.258C521.205,220.892,521.153,235.7,521.149,251Z",
    transform: "translate(-69 -54)",
    fill: "#62605f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M489.919,519.874a122.536,122.536,0,0,0,22.458-41.8c.646-2.086.849-4.991,4.4-3.278-4.565,30.729-43.031,75.983-70.559,81.042,1.351-1.346,2.474-3.128,4.088-3.969A126.976,126.976,0,0,0,489.919,519.874Z",
    transform: "translate(-69 -54)",
    fill: "#6d6d6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M521.146,367c-.032,27.99-.033,55.48-.16,82.969-.01,2.051,1.191,5.481-3.187,5.1v-139.7l1.855-.52c.5,1.556,1.427,3.109,1.438,4.668C521.2,335.178,521.15,350.839,521.146,367Z",
    transform: "translate(-69 -54)",
    fill: "#62605f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrban);
export default __webpack_public_path__ + "static/media/Urban.5bd4c554fd7644c347003c0aeb818b13.svg";
export { ForwardRef as ReactComponent };